export default __webpack_public_path__ + "assets/logo_resurs-bfb09999.svg";